<template>
  <div class="tlbar">
    <div class="tlbar-tlbox">
      <slot>
        <h3 class="tlbar-tlbox-title">{{ title }}</h3>
        <div class="tlbar-tlbox-subtitle">{{ subtitle }}</div>
      </slot>
    </div>
    <div v-if="showmore" class="tlbar-more">
      <!-- <router-link class="tlbar-more" :to="to"> 更多>></router-link> -->
      <div class="tlbar-more" @click="navToMore">更多</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "深度阅读",
    },
    subtitle: {
      type: String,
      default: "Deep reading",
    },
    showmore: {
      type: Boolean,
      default: true,
    },
    to: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    navToMore() {
      console.log("navto", this.to);
      // let rules = {
      //   1:'深度阅读',
      //   2:'有知',
      //   3:'视频讲堂',
      //   4:'青青听',
      //   5:'青青写',
      // }
      // 0 代表不需要权限
      let rule = [0];
      if (this.getMenu().length) {
        this.getMenu().forEach((item, index) => {
          switch (item.title) {
            case "深度阅读":
              rule.push(1);
              break;
            case "有知":
              rule.push(2);
              break;
            case "视频讲堂":
              rule.push(3);
              break;
            case "青青听":
              rule.push(4);
              break;
            case "青青写":
              rule.push(5);
              break;
          }
        });
      }

      if (rule.includes(this.to.meta.type)) {
        this.$router.push(this.to);
      }else{
        this.$message.closeAll();
        this.$message({
           message: "暂无权限,请与图书馆联系",
          offset: 400,
          type:'warning'
        })
      }
    },
    getMenu() {
      let menuList = JSON.parse(sessionStorage.getItem("menu"));
      return menuList;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.tlbar {
  @title_color: #333;
  @sub_color: #3370ff;
  @gray: #999999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &-tlbox {
    display: flex;
    align-items: center;
    &-title {
      font-size: 26px;
      font-weight: bold;
      color: @title_color;
      &::after {
        display: block;
        content: "";
        margin-top: 6px;
        width: 100%;
        height: 10px;
        border-radius: 5px;

        background-color: @sub_color;
      }
    }
    &-subtitle {
      margin-left: 40px;
      color: #999999;
      font-size: 16px;
    }
  }
  &-more {
    color: @gray;
    font-size: 15px;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/titleBar.vue